import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import type { AuthStateType } from '../types'
import { useAuthStore, isAuthState } from '../store'

export function useAuthToken () {
    const state = useAuthStore(useShallow(({ state }) => state))
    return state.type === 'LoggedIn' ? state.data.token : null
}

export function useAuthUser() {
    const state = useAuthStore(useShallow(({ state }) => state))
    return state?.data && 'user' in state.data ? state.data.user : null
}

export function useUserOrigin() {
    const state = useAuthStore(useShallow(({ state }) => state))
    return state?.data?.origin || null
}

export function useAuthStateIs(target: AuthStateType) {
    const state = useAuthStore(useShallow(({ state }) => state))
    return React.useMemo(
        () => isAuthState(state, [target]),
        [state],
    );
}
